import api from 'Application/api/api';

const setCo2Savings = async (signal, values) => {
	const response = await api.patch('/finances/set-co2-savings', values, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
	};
};

export default setCo2Savings;
